import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleBudgetChapter } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheBudgetChapterComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const budgetChapterDataCombo = computed(() => {
    return store.getters[`${ModuleBudgetChapter}/items`].filter(x => x.active);
  });

  // config columns combo
  const cacheBudgetChapterComboConfig = reactive({
    data: budgetChapterDataCombo,
    columns: [
      {
        title: 'Mã chương',
        dataField: 'budget_chapter_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên chương',
        dataField: 'budget_chapter_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_chapter_code',
    valueField: 'budget_chapter_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'budget_chapter_id',
      titleSearch: 'Tìm nhanh chương',
    },
  });
  return {
    cacheBudgetChapterComboConfig,
  };
};
